import { combineReducers } from "redux";
import massMailer from "../../component/screens/massMailer/massMailerReducer";
import storageSession from "redux-persist/lib/storage/session";
import localSession from "redux-persist/lib/storage";
import loading from "../../component/containers/loader/LoaderReducer";
import ServiceErrorReducer from "../../common/ServiceError/ServiceErrorReducer";
import accessDetails from "./accessDetailsReducer";
import mmApprovalReqDetails from "../../component/containers/mmApprovalReqDetails/mmApprovalReqDetailsReducer";
import mmNewRequest from "../../component/containers/mmNewRequest/mmNewRequestReducer";
import mmApproversDetails from "../../component/containers/mmApproversDetails/mmApproversDetailsReducer";
import mmSendMassEmailReqDetails from "../../component/containers/mmSendMassEmailReqDetails/mmSendMassEmailReqDetailsReducer";
import helpDeskReducer from "../../component/containers/helpDesk/helpDeskReducer";

const rootReducer = combineReducers({
	loading: loading,
	massMailer: massMailer,
	mmApprovalReqDetails: mmApprovalReqDetails,
	mmNewRequest: mmNewRequest,
	serviceError: ServiceErrorReducer,
	accessDetails: accessDetails,
	mmApproversDetails: mmApproversDetails,
	mmSendEmailReqDetails: mmSendMassEmailReqDetails,
	helpDeskReducer: helpDeskReducer,
});

const appReducer = (state, action) => {
	if (action.type === "CLEAR_STORE") {
		storageSession.removeItem(`persist:MM`);
		localSession.removeItem(`persist:MM`);
		state = undefined;
	}
	if (action.type === "CLEAR_MASSMAILER") {
		state = { ...state, massMailer: undefined };
	}
	if (action.type === "CLEAR_SERVICEERROR") {
		state = { ...state, serviceError: undefined };
	}
	if (action.type === "CLEAR_ALL") {
		state = undefined;
	}
	return rootReducer(state, action);
};
export default appReducer;
